export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Latin2-c26797e2920f701bf68f403fe043cba0.woff2";